import CardModifier from './CardModifier';
import GameObject from '../../../../GameObject/GameObject';
import AnimationFrame from '../../../../Component/AnimationFrame';
import Point from '../../../../Utility/Point';

export default class FogModifier extends CardModifier {
    onCreate(params: any): void {
        super.onCreate(params);

        const fog = GameObject.Instantiate(AnimationFrame, {
            name: 'fog_sprite',
            resourceName: 'CardsVFX',
            animationName: 'fog',
            autoStart: true,
            frameRate: 1000 / 130,
            anchor: Point.Center,
        });
        this.addChild(fog);
    }
}
